// composables/useHydrated.ts
export const useHydrated = () => {
  const isHydrated = ref(false)
  onMounted(() => {
    // 此时 DOM 已挂载，hydration 通常已完成
    isHydrated.value = true
  })

  return { isHydrated }
}
